/** @format */

const template = `
<ng-form name="{{::$ctrl.formName}}">
  <div
    ng-repeat="responsibilityInfo in $ctrl.responsibilityInfos track by $index"
    class="responsibility-row form-group grouping-panel"
    data-cy="responsibility-info-row"
    ng-class="{ last: $last }">
    <label translate="SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.RESPONSIBILITY_INFO" translate-value-index="{{ $index + 1 }}"></label
    ><!--
      --><button
      type="button"
      class="link-button"
      title="{{::'SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.REMOVE'|translate}}"
      ng-click="$ctrl.remove(responsibilityInfo)"
      aria-label="{{::'SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.REMOVE'|translate}} {{
        'SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.RESPONSIBILITY_INFO' | translate: { index: $index + 1 }
      }}">
      <sis-icon icon="delete"></sis-icon>
    </button>
    <div class="grouping-panel-content">
      <ng-form name="responsibilityInfo{{ $index }}">
        <div class="row">
          <div ng-if="$ctrl.loaded" class="col-12 col-md-6 not-localized form-group">
            <label translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.ROLE</label>
            <sis-code-select-editor
              [codebook-urn]="$ctrl.responsibilityInfoTypeUrn"
              (on-select-code)="$ctrl.roleChanged($index, $event.selectedUrn)"
              name="educationResponsibilityInfoTypeUrn"
              [required]="true"
              [show-errors]="true"
              [selected-urn]="responsibilityInfo.roleUrn"
              [university-codes]="$ctrl.universityCodes"
              [show-all-language-versions]="$ctrl.displayAllLanguages()"
              data-cy="responsibility-info-role-urn-editor"
              [allow-selected-urn-change-detection]="true">
            </sis-code-select-editor>
          </div>

          <div class="col-12 col-md-6 not-localized form-group">
            <label translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.PERSON</label>
            <search-employee
              name="person"
              employee="responsibilityInfo.person"
              employee-service="$ctrl.employeeService"
              on-select="$ctrl.personSelected(responsibilityInfo, personObj)"
              data-cy="search-person">
            </search-employee>
          </div>

          <div class="col-12 localized form-group">
            <localized-string-editor
              name="text_{{ $index }}"
              ng-model="responsibilityInfo.text"
              min-length="{{::$ctrl.textMinLength}}"
              max-length="{{::$ctrl.textMaxLength}}"
              on-change-call-back="$ctrl.handleChange()">
              <label translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.ADDITIONAL</label>
            </localized-string-editor>
          </div>
        </div>
        <div ng-if="!$ctrl.hideValidity" class="row">
          <div class="col-12 validity-row" ng-hide="responsibilityInfo.editValidity">
            <div class="form-group-mimic">
              <label translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.VALIDITY_PERIOD</label>
              <span
                ng-if="
                  responsibilityInfo.validityPeriod &&
                  (responsibilityInfo.validityPeriod.endDate || responsibilityInfo.validityPeriod.startDate)
                "
                >{{ responsibilityInfo.validityPeriod | localDateRange }}</span
              >
              <span
                class="ng-hide"
                ng-hide="
                  responsibilityInfo.validityPeriod &&
                  (responsibilityInfo.validityPeriod.endDate || responsibilityInfo.validityPeriod.startDate)
                "
                translate
                >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.EMPTY_VALIDITY</span
              >
              <button
                type="button"
                class="link-button"
                ng-click="responsibilityInfo.editValidity = true"
                aria-label="{{::'ARIA_LABEL.EDIT_VALIDITY_PERIOD' | translate}}"
                translate
                >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.EDIT</button
              >
            </div>
          </div>

          <div class="col-12 validity-row" ng-show="responsibilityInfo.editValidity">
            <div class="grouping-panel">
              <label translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.VALIDITY_PERIOD</label>
              <button
                type="button"
                class="link-button"
                ng-click="responsibilityInfo.editValidity = false"
                aria-label="{{ 'ARIA_LABEL.CLOSE_EDIT_VALIDITY_PERIOD' | translate }}"
                translate
                >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.CLOSE</button
              >
              <div class="grouping-panel-content form-group">
                <local-date-range-editor
                  name="validityPeriod"
                  required="false"
                  ng-model="responsibilityInfo.validityPeriod"
                  on-change="$ctrl.handleChange()"></local-date-range-editor>
              </div>
            </div>
          </div>
        </div>

        <div ng-if="$ctrl.isTitleEnabled()">
          <person-title-selector
            person-id="responsibilityInfo.personId"
            additional-info="responsibilityInfo.text"
            init-title="responsibilityInfo.title"
            required="false"
            disabled="false"
            on-change="$ctrl.handleTitleChange(responsibilityInfo, title)"
            dropdown-additional-classes="dropdown-full-width">
            <custom-title-help>
              <span class="help-block" translate>STUDENT_APPLICATIONS.PROVIDE_TITLE_IN_OFFICIAL_LANGUAGES</span>
            </custom-title-help>
          </person-title-selector>
        </div>
      </ng-form>
    </div>
  </div>

  <div class="row add-new">
    <div class="col-md-12">
      <button type="button" class="link-button" ng-click="$ctrl.addNew()" data-cy="add-responsibility-info">
        <sis-icon icon="ring-plus"></sis-icon>{{ "SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.ADD" | translate }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ul class="error-list" role="alert">
        <li ng-if="$ctrl.validateHasDuplicatePersonsWithSameRole()" translate
          >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.HAS_DUPLICATE_PERSONS_WITH_SAME_ROLE</li
        >

        <li ng-if="$ctrl.validateSomeItemsWithoutRoleUrn()" translate>SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.ROLE_MISSING</li>

        <li ng-if="$ctrl.validateSomeItemsWithoutPersonIdOrInfoText()" translate
          >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.PERSON_AND_INFO_TEXT_MISSING_FOR_ROLE</li
        >

        <li ng-if="$ctrl.validateUnderMinCount()" translate translate-value-count="{{ $ctrl.minCountInt }}"
          >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.TOO_FEW</li
        >

        <li ng-if="$ctrl.validateOverMaxCount()" translate translate-value-count="{{ $ctrl.maxCountInt }}"
          >SIS_COMPONENTS.PERSON.RESPONSIBILITY_INFO_EDITOR.TOO_MANY</li
        >
      </ul>
    </div>
  </div>
</ng-form>
`;
export default template;
